import { useMutation } from '@tanstack/react-query';
import { confirmPasswordReset } from 'firebase/auth';
import { auth } from 'src/config/firebase';
import { IAuthConfirmPasswordResetPayload } from '../interfaces/auth';

export function useAuthConfirmPasswordReset() {
  return useMutation({
    mutationFn: async (payload: IAuthConfirmPasswordResetPayload) => {
      const { oobCode, newPassword } = payload;
      await confirmPasswordReset(auth, oobCode, newPassword);
    },
  });
}
